import type {
  HeroImagesJson,
  HeroImageUploadItem,
} from './PartnerCreatePage';

export function stripHeroImageFiles(heroImagesJson: HeroImagesJson) {
  const stripItem = (item: HeroImageUploadItem | null) => {
    if (!item) return null;

    return {
      clientKey: item.clientKey,
      sourceType: 'UPLOAD',
      originalFileName: item.originalFileName,
      sortOrder: item.sortOrder,
    };
  };

  return {
    mobile: {
      main: stripItem(heroImagesJson.mobile.main),
      items: heroImagesJson.mobile.items.map(stripItem),
    },
    desktop: {
      main: stripItem(heroImagesJson.desktop.main),
      items: heroImagesJson.desktop.items.map(stripItem),
    },
  };
}

export function appendHeroImageFiles(formData: FormData, heroImagesJson: HeroImagesJson) {
  const appendItem = (fieldName: string, item: HeroImageUploadItem | null) => {
    if (!item?.file) return;

    formData.append(fieldName, item.file);
  };

  appendItem('heroImages.mobile.main', heroImagesJson.mobile.main);

  heroImagesJson.mobile.items.forEach((item, index) => {
    appendItem(`heroImages.mobile.items.${index}`, item);
  });

  appendItem('heroImages.desktop.main', heroImagesJson.desktop.main);

  heroImagesJson.desktop.items.forEach((item, index) => {
    appendItem(`heroImages.desktop.items.${index}`, item);
  });
}